import { z } from 'zod';

export const oneOffPaymentNoticeDeleteRequestSchema = z.object({ date: z.string(), reference: z.string() });
